import VpsRental from "./vps-rental.page";

export default VpsRental;
